'use client';
import DevClickOpener from '@repo/ui/src/components/DevClickOpener';
import { SwitchLiveCallback } from '@components/Analytics/SwitchLiveCallback';
import { useOnRouteChange } from '@hooks/useOnRouteChange';
import { identify } from '@repo/ui/src/utils/identify';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import { removeQueryParam } from '@utils/removeQueryParam';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import Cookies from 'js-cookie';
import { ReadonlyURLSearchParams, usePathname, useRouter } from 'next/navigation';
import React from 'react';
/// <reference types="../src/types/window" />

// Declare window.identify for Vercel build compatibility
declare global {
  interface Window {
    identify: (email: string) => Promise<void>;
  }
}

gsap.registerPlugin(ScrollTrigger);

export interface TemplateProps {
  children: React.ReactNode;
}

const Template = ({ children }: TemplateProps) => {
  const isProd = publicRuntimeConfig.appEnv === 'production';
  const { refresh } = useRouter();
  const previousUrl = React.useRef<string>('');
  const pathname = usePathname();

  React.useEffect(() => {
    window.identify = async (email: string) => {
      identify({ email });
    };
    previousUrl.current = `${window.location.host}${pathname}`;
    // fix referrer on client side routing
    window.__ANALYTICS_REFERRER__ = document.referrer;
  }, [pathname]);

  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('basket')) {
      if (!Cookies.get('isBasketLink')) {
        return refresh();
      }
      removeQueryParam(searchParams as ReadonlyURLSearchParams, 'basket');
    }
  }, [refresh]);

  useOnRouteChange(() => {
    window.__ANALYTICS_REFERRER__ = previousUrl.current;
    previousUrl.current = `${window.location.host}${pathname}`;
  });

  return (
    <>
      <SwitchLiveCallback />
      {!isProd && <DevClickOpener />}
      {children}
    </>
  );
};

export default Template;
